const ADD_SHARE_COUNT = 'events/ADD_SHARE_COUNT';

const FETCH_AUTHOR_INFO = 'events/FETCH_AUTHOR_INFO';

const FETCH_AUTHOR_RANKS = 'events/FETCH_AUTHOR_RANKS';

const FETCH_READER_INFO = 'events/FETCH_READER_INFO';

const FETCH_VOTE_EVENT_STORIES = 'events/FETCH_VOTE_EVENT_STORIES';

// thanksgiving
const FETCH_MISSION_EVENTS = 'events/FETCH_MISSION_EVENTS';

const POST_MISSION = 'events/POST_MISSION';

const MISSION_COMPLETE = 'events/MISSION_COMPLETE';

const POST_MISSION_RESULT = 'events/POST_MISSION_RESULT';

export default {
  ADD_SHARE_COUNT,
  FETCH_AUTHOR_INFO,
  FETCH_AUTHOR_RANKS,
  FETCH_READER_INFO,
  FETCH_VOTE_EVENT_STORIES,
  FETCH_MISSION_EVENTS,
  POST_MISSION,
  MISSION_COMPLETE,
  POST_MISSION_RESULT,
};



// WEBPACK FOOTER //
// ./src/app/redux/events/types.js